var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImport = function SvgImport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.882 5.28c7.777 0 14.083 6.306 14.083 14.085 0 7.779-6.306 14.085-14.083 14.085C7.1 33.453.795 27.143.795 19.365.795 11.587 7.1 5.28 14.882 5.28Z",
    fill: "#E0F2FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#import_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.38 22-2.5-2.5m0 0-2.5 2.5m2.5-2.5v5.626m5.244-1.631a3.125 3.125 0 0 0-1.494-5.87h-.787a5 5 0 1 0-8.588 4.563",
    stroke: "#0086C9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "import_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.38 12)",
    d: "M0 0h15v15H0z"
  })))));
};

export default SvgImport;